/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Col_TasksInputs */

const en_fw_bm_col_tasks = /** @type {(inputs: Fw_Bm_Col_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

const id_fw_bm_col_tasks = /** @type {(inputs: Fw_Bm_Col_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Fw_Bm_Col_TasksInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_col_tasks = /** @type {((inputs?: Fw_Bm_Col_TasksInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Col_TasksInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_col_tasks(inputs)
	return en_fw_bm_col_tasks(inputs)
});